import $ from 'jquery';
import { createResponseError } from '../data-utility/conversion-utility';

export class MmcPlainDataSource {
  constructor({
    routePrefix,
    endpoint,
    entityName,
  }) {
    this.url = this.getUrl(routePrefix, endpoint, entityName);
  }

  getUrl(routePrefix, endpoint, entityName) {
    return `${this.getBmcMtEndpoint()}/${routePrefix}${endpoint}${entityName}`;
  }

  getBmcMtEndpoint() {
    const url = window.location.href;
    let endPoint = 'https://mmcapi.ads.microsoft.com';
    if (url.includes('ads-int.microsoft.com') || url.includes('si.bingads.microsoft.com')) {
      if (url.includes('beta')) {
        endPoint = 'https://beta.mmcapi.ads-int.microsoft.com';
      } else {
        endPoint = 'https://mmcapi.ads-int.microsoft.com';
      }
    } else if (url.includes('localhost.redmond.corp.microsoft.com')) {
      endPoint = 'https://campaign-mockci2.mmcapi.ads-int.microsoft.com';
    }
    return endPoint;
  }

  addParams2Url(url, params) {
    const urlObject = new URL(url);
    if (params) {
      Object.keys(params).forEach((key) => {
        urlObject.searchParams.append(key, params[key]);
      });
    }
    return urlObject.toString();
  }

  triggerAjaxWithPromise(url, method, params = null) {
    return $.ajax({
      url,
      type: method,
      contentType: 'application/json',
      data: params ? JSON.stringify(params) : null,
      xhrFields: {
        withCredentials: true,
      },
    })
      .then((response) => {
        const { ResponseObject } = response;
        if (ResponseObject) {
          return ResponseObject;
        }
        throw response;
      })
      .catch((response) => {
        const exception = createResponseError(
          response.status,
          response.responseJSON,
          response.statusText,
          response.responseText,
          response.errors
        );
        throw exception;
      });
  }

  async get(params) {
    const finalUrl = this.addParams2Url(this.url, params);
    return this.triggerAjaxWithPromise(finalUrl, 'GET');
  }

  async post(params) {
    return this.triggerAjaxWithPromise(this.url, 'POST', params);
  }
}
